import { apiGet, apiPost } from './http';

/** 候補名單（封測期間）。公開端點，不需要登入。 */
export const waitlistApi = {
  join: (email: string, source: 'landing' | 'register', note?: string) =>
    apiPost<{ joined: true }>('/waitlist', {
      email,
      source,
      ...(note === undefined || note === '' ? {} : { note }),
    }),
};

/**
 * 註冊頁開場問一次：現在是開放註冊還是邀請制。
 *
 * 帶邀請碼來的人也問得到答案——碼有效就照常給表單，不用先撞一次 403。
 */
export const registrationApi = {
  status: (code?: string) =>
    apiGet<{ open: boolean }>(
      code === undefined || code === ''
        ? '/auth/registration-status'
        : `/auth/registration-status?code=${encodeURIComponent(code)}`,
    ),
};
